import React, { useState, useEffect } from "react";
import {
  Table,
  Typography,
  Tag,
  DatePicker,
  Card,
  Image,
  Space,
  Button,
  Drawer,
  Form,
  Row,
  Col,
  Input,
  InputNumber,
  Select,
  notification,
  Popover,
  Upload,
  message,
  Descriptions,
} from "antd";
import Spinner from "../components/Spinner";
import {
  completeRefund,
  getDeliveryPaymentReport,
  getRefundReadyList,
  getRefundableList,
  readyRefund,
} from "../api/api";
import moment from "moment";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import Status from "../components/Status";
import { DollarOutlined } from "@ant-design/icons";
import axios from "axios";
import { cdnUrl } from "../utils/url";
import getError from "../utils/getError";
import { useSelector } from "react-redux";
import CustomerName from "../components/CustomerName";
import { isPermitted } from "../utils/PermissionManager";
const { Column } = Table;
const { Text } = Typography;

export default function ReadyRefundsNew() {
  const [data, setData] = useState(null);
  const [drawer, setDrawer] = useState(null);
  const [pgw, setPgw] = useState(null);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(null);
  const [reload, setReload] = useState(5);
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const roles = useSelector((state) => state.auth.profile?.roles);
  const [filter, setFilter] = useState({
    date: moment(new Date()).format("YYYY-MM-DD"),
  });
  useEffect(() => {
    window.scrollTo({ top: 0 });
    getRefundReadyList(setData, filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, reload]);

  const monthFormat = "YYYY/MM/DD";

  const config = useSelector((state) => state.config.config);

  let mStyle = {
    cursor: "pointer",
    textTransform: "capitalize",
    marginRight: "0.5rem",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    color: "black",
    padding: "1rem",
    backgroundColor: "white",
    width: "256px",
  };

  const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
      message: message,
      description: description,
    });
  };

  const afterPerform = (result, message) => {
    setLoading(false);
    setDrawer(null);
    setFile(null);
    form.resetFields();
    if (result) {
      setReload(Math.random());
      openNotificationWithIcon("success", "Success", "updated successfully");
    } else {
      openNotificationWithIcon("error", "Failed", message || "update failed");
    }
  };

  const getCategoryDef = (category) => {
    let mCat = config?.refund_categories?.find((el) => el.value === category);
    if (mCat) {
      return mCat.name;
    }
    return "";
  };

  function beforeUpload(file, name) {
    if (
      file.type === "image/png" ||
      file.type === "image/jpeg" ||
      file.type === "image/jpeg" ||
      file.name.includes("pdf") ||
      file.name.includes("docx")
    ) {
      setFile(file);
    } else {
      message.error(`${file.name} is not a valid file`);
    }
    return false;
  }

  return (
    <div>
      <Card size="small" style={{ marginBottom: "1rem" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: 16 }}>Ready Refunds</span>
        </div>
      </Card>
      {data && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            marginBottom: "1rem",
            marginTop: "1rem",
          }}
          className="report"
        >
          <div style={mStyle}>
            <Tag color="magenta">{data.order_count?.toLocaleString() || 0}</Tag>
            <h3 className="mt05">Total Orders</h3>
          </div>
          <div style={mStyle}>
            <Tag color="blue">
              {data.customer_count?.toLocaleString() || 0}
            </Tag>
            <h3 className="mt05">Total Customers</h3>
          </div>
          <div style={mStyle}>
            <Tag color="#87d068">
              ৳{data.refundable_amount?.toLocaleString() || 0}
            </Tag>
            <h3 className="mt05">Total Refundable</h3>
          </div>

          <div style={mStyle}>
            <Space size={4}>
              <Tag color="volcano">{data.requested_count || 0}</Tag>
              <Tag color="orange">
                ৳{data.requested_amount?.toLocaleString() || 0}
              </Tag>
            </Space>
            <h3 className="mt05">Requested</h3>
          </div>

          <div style={mStyle}>
            <Space size={4}>
              <Tag color="default">{data.non_requested_count || 0}</Tag>
              <Tag color="default">
                ৳{data.non_requested_amount?.toLocaleString() || 0}
              </Tag>
            </Space>
            <h3 className="mt05">Non Requested</h3>
          </div>

          <div style={mStyle}>
            <Space size={4}>
              <Tag color="#108ee9">{data.bkash_count || 0}</Tag>
              <Tag color="#108ee9">
                ৳{data.bkash_amount?.toLocaleString() || 0}
              </Tag>
            </Space>
            <h3 className="mt05">Bkash</h3>
          </div>

          <div style={mStyle}>
            <Space size={4}>
              <Tag color="#722ed1">{data.wallet_count || 0}</Tag>
              <Tag color="#722ed1">
                ৳{data.wallet_amount?.toLocaleString() || 0}
              </Tag>
            </Space>
            <h3 className="mt05">Wallet</h3>
          </div>

          <div style={mStyle}>
            <Space size={4}>
              <Tag color="#2db7f5">{data.bank_count || 0}</Tag>
              <Tag color="#2db7f5">
                ৳{data.bank_amount?.toLocaleString() || 0}
              </Tag>
            </Space>
            <h3 className="mt05">Bank</h3>
          </div>

          {data.total_profit !== null && (
            <div style={mStyle}>
              <Tag color="gold">৳{data.total_profit?.toLocaleString()}</Tag>
              <h3 className="mt05">Profit</h3>
            </div>
          )}
        </div>
      )}

      <div>
        {data ? (
          <div className="section-to-print">
            <Table
              dataSource={data?.customers}
              rowKey={(record) => record.code}
              pagination={false}
              bordered
            >
              <Column
                title="Customer"
                dataIndex="code"
                key="code"
                render={(text, record, index) => (
                  <div>
                    <CustomerName data={record} />
                  </div>
                )}
              />

              <Column
                title="Requested"
                key="requested"
                render={(text, record) => {
                  if (!record.requests || record.requests.length === 0)
                    return "--";
                  return (
                    <Space
                      direction="vertical"
                      style={{ width: "100%" }}
                      size="middle"
                    >
                      {record.requests.map((req, idx) => (
                        <Table
                          key={idx}
                          dataSource={req.orders}
                          rowKey="code"
                          pagination={false}
                          size="small"
                          bordered
                          title={() => (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <Status name={req.method} />
                              <Text
                                type="secondary"
                                style={{ fontSize: 11, fontWeight: "500" }}
                              >
                                {req.method === "bank"
                                  ? `${req.detail?.bank_name} - ${req.detail?.account_number}`
                                  : req.detail?.account_number}
                              </Text>
                            </div>
                          )}
                          columns={[
                            {
                              title: "Order",
                              dataIndex: "code",
                              key: "code",
                              render: (code, p) => (
                                <Popover
                                  content={
                                    <div style={{ maxWidth: 300 }}>
                                      <p>
                                        <strong>Reason:</strong>{" "}
                                        {p.refund?.reason}
                                      </p>
                                    </div>
                                  }
                                >
                                  <Link to={`/order/${code}`}>
                                    <Text style={{ fontSize: 11 }}>
                                      #{code}
                                    </Text>
                                  </Link>
                                </Popover>
                              ),
                            },
                            {
                              title: "Category",
                              key: "category",
                              render: (_, p) => (
                                <Status
                                  name={getCategoryDef(p.refund?.category)}
                                />
                              ),
                            },
                            {
                              title: "Amount",
                              key: "amount",
                              align: "right",
                              render: (_, p) => (
                                <Text style={{ fontSize: 11 }}>
                                  ৳
                                  {p.refund?.refundable_amount?.toLocaleString()}
                                </Text>
                              ),
                            },
                          ]}
                          summary={() => (
                            <Table.Summary fixed>
                              <Table.Summary.Row>
                                <Table.Summary.Cell index={0} colSpan={2}>
                                  {isPermitted(roles, [
                                    "accountant",
                                    "master_admin",
                                  ]) &&
                                    record.requests?.length > 0 && (
                                      <Button
                                        type="primary"
                                        onClick={() => {
                                          setDrawer({
                                            ...record,
                                            current_request: req,
                                          });
                                        }}
                                        size="small"
                                        style={{
                                          backgroundColor: "#D80032",
                                        }}
                                      >
                                        Refund
                                      </Button>
                                    )}
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={1} align="right">
                                  <Text strong>
                                    ৳
                                    {req.orders
                                      ?.reduce(
                                        (sum, p) =>
                                          sum +
                                          (p.refund?.refundable_amount || 0),
                                        0,
                                      )
                                      .toLocaleString()}
                                  </Text>
                                </Table.Summary.Cell>
                              </Table.Summary.Row>
                            </Table.Summary>
                          )}
                        />
                      ))}
                    </Space>
                  );
                }}
              />

              <Column
                title="Non Requested"
                key="non_requested"
                render={(text, record) => {
                  if (
                    !record.non_requested ||
                    record.non_requested.length === 0
                  )
                    return "--";
                  return (
                    <Space
                      direction="vertical"
                      style={{ width: "100%" }}
                      size="middle"
                    >
                      <Table
                        dataSource={record.non_requested}
                        rowKey="code"
                        pagination={false}
                        size="small"
                        bordered
                        columns={[
                          {
                            title: "Order",
                            dataIndex: "code",
                            key: "code",
                            render: (code, p) => (
                              <Popover
                                content={
                                  <div style={{ maxWidth: 300 }}>
                                    <p>
                                      <strong>Reason:</strong>{" "}
                                      {p.refund?.reason}
                                    </p>
                                  </div>
                                }
                              >
                                <Link to={`/order/${code}`}>
                                  <Text style={{ fontSize: 11 }}>#{code}</Text>
                                </Link>
                              </Popover>
                            ),
                          },
                          {
                            title: "Category",
                            key: "category",
                            render: (_, p) => (
                              <Status
                                name={getCategoryDef(p.refund?.category)}
                              />
                            ),
                          },
                          {
                            title: "Amount",
                            key: "amount",
                            align: "right",
                            render: (_, p) => (
                              <Text style={{ fontSize: 11 }}>
                                ৳{p.refund?.refundable_amount?.toLocaleString()}
                              </Text>
                            ),
                          },
                        ]}
                      />
                    </Space>
                  );
                }}
              />

              <Column
                title="Refundable"
                key="amount"
                align="center"
                render={(text, record) => (
                  <Text type="danger">৳{record.refundable_amount}</Text>
                )}
              />

              <Column
                title="Total Profit"
                key="amount"
                align="center"
                render={(text, record) => (
                  <Text>৳{record.total_profit || 0}</Text>
                )}
              />
            </Table>
          </div>
        ) : (
          <Spinner />
        )}
      </div>

      <Drawer
        title={"Confirm Refund"}
        open={drawer ? true : false}
        width={window.innerWidth > 768 ? "40%" : "60%"}
        onClose={() => {
          setDrawer(0);
          form.resetFields();
          setFile(null);
          setPgw(null);
          setLoading(false);
        }}
      >
        <div style={{}}>
          <Descriptions
            bordered
            size="small"
            column={1}
            style={{ marginBottom: "1rem" }}
          >
            <Descriptions.Item label="Customer">
              {drawer?.name} ({drawer?.phone})
            </Descriptions.Item>
            {drawer?.current_request && (
              <>
                <Descriptions.Item label="Method">
                  <Tag color="cyan">
                    {drawer.current_request.method?.toUpperCase()}
                  </Tag>
                </Descriptions.Item>
                {drawer.current_request.detail &&
                  Object.entries(drawer.current_request.detail).map(
                    ([key, value]) =>
                      value && (
                        <Descriptions.Item
                          key={key}
                          label={key
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, (l) => l.toUpperCase())}
                        >
                          {value}
                        </Descriptions.Item>
                      ),
                  )}
              </>
            )}
          </Descriptions>
          <Table
            dataSource={drawer?.current_request?.orders}
            rowKey={(record) => record.code}
            pagination={false}
            bordered
            style={{ marginBottom: "2rem" }}
            // summary={() => (
            //   <>
            //     <Table.Summary.Row>
            //       <>
            //         <Table.Summary.Cell index={3} colSpan={2} align="center">
            //           <p
            //             style={{
            //               textAlign: "right",
            //               width: "100%",
            //             }}
            //           >
            //             Total
            //           </p>
            //         </Table.Summary.Cell>
            //         <Table.Summary.Cell index={3} align="center">
            //           <span>৳{drawer?.refundable_amount}</span>
            //         </Table.Summary.Cell>
            //         <Table.Summary.Cell index={4} align="center">
            //           <span>৳{drawer?.total_profit || 0}</span>
            //         </Table.Summary.Cell>
            //       </>
            //     </Table.Summary.Row>
            //   </>
            // )}
          >
            <Column
              title="Order"
              dataIndex="code"
              key="code"
              render={(text, record, index) => (
                <Link to={`/order/${record.code}`}>
                  <Text>#{record.code}</Text>
                </Link>
              )}
            />

            <Column
              title="Category"
              key="amount"
              align="center"
              render={(text, record) => (
                <Status name={getCategoryDef(record.refund?.category)} />
              )}
            />

            <Column
              title="Refundable"
              key="amount"
              align="center"
              render={(text, record) => (
                <Text type="danger">৳{record.refund?.refundable_amount}</Text>
              )}
            />

            <Column
              title="Profit"
              key="amount"
              align="center"
              render={(text, record) => (
                <Text type="danger">৳{record.refund?.profit || 0}</Text>
              )}
            />
          </Table>

          <Form
            name="basic"
            layout="vertical"
            form={form}
            onFinish={async (e) => {
              if (e.method !== "balance" && e.method !== "bkash" && !file) {
                openNotificationWithIcon(
                  "error",
                  "Failed",
                  "Please attach a slip",
                );
                return null;
              }

              let mData = {};

              if (file) {
                try {
                  let formData = new FormData();
                  formData.append("file", file);
                  let res = await axios.post(
                    cdnUrl + "/upload/file/bankslip",
                    formData,
                  );
                  if (res?.data?.result?.file) {
                    mData.file = res?.data?.result?.file;
                  }
                } catch (error) {
                  afterPerform(false, getError(error));
                }
              }

              setLoading(true);
              mData.method = e.method;
              if (e.method === "bank") {
                mData.pgw_info = {
                  bank_name: e.bank_name,
                  branch: e.branch,
                  acc_name: e.acc_name,
                  routing_number: e.routing_number,
                  acc_number: e.acc_number,
                };
              } else {
                if (e.acc_number) {
                  mData.pgw_info = {
                    acc_number: e.acc_number,
                  };
                } else {
                  mData.pgw_info = {};
                }
              }
              completeRefund(drawer?.current_request?._id, mData, afterPerform);
            }}
          >
            <Row gutter={[16, 0]} style={{ marginBottom: "1rem" }}>
              <Col xs={{ span: 24 }} md={{ span: 24 }}>
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#f5f5f5",
                    width: "160px",
                    height: "160px",
                  }}
                >
                  {file && (
                    <div style={{ width: "100%" }}>
                      <img
                        style={{
                          width: "160px",
                          height: "160px",
                          objectFit: "contain",
                          border: "1px solid #ddd",
                        }}
                        src={URL.createObjectURL(file)}
                        alt=""
                      />
                    </div>
                  )}
                </div>
                <Upload
                  multiple={false}
                  showUploadList={false}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  beforeUpload={(file) => beforeUpload(file)}
                >
                  <Button style={{ marginTop: "1rem", marginBottom: 16 }}>
                    Upload Slip
                  </Button>
                </Upload>
              </Col>

              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <Form.Item
                  label="Refund Gateway"
                  name="method"
                  rules={[
                    {
                      required: true,
                      message: "This field is required !",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%" }}
                    onSelect={(e) => {
                      setPgw(e);
                    }}
                  >
                    <Select.Option value={"bkash"}>Bkash</Select.Option>
                    <Select.Option value={"nagad"}>Nagad</Select.Option>
                    <Select.Option value={"bank"}>Bank</Select.Option>
                    <Select.Option value={"cash"}>Cash</Select.Option>
                    <Select.Option value={"balance"}>Balance</Select.Option>
                  </Select>
                </Form.Item>
              </Col>

              {(pgw === "bkash" || pgw === "nagad") && (
                <Col xs={{ span: 24 }} md={{ span: 12 }}>
                  <Form.Item
                    label="Account Number"
                    name="acc_number"
                    rules={[
                      {
                        required: true,
                        message: "This field is required !",
                      },
                    ]}
                  >
                    <Input placeholder="Account Number" />
                  </Form.Item>
                </Col>
              )}

              {pgw === "bank" && (
                <Col>
                  <Row
                    style={{
                      background: "#f6f6f6",
                      padding: 12,
                      borderRadius: 6,
                      marginTop: 8,
                      marginBottom: 8,
                    }}
                    gutter={[12, 0]}
                  >
                    <Col xs={{ span: 24 }} md={{ span: 12 }}>
                      {" "}
                      <Form.Item
                        label="Bank Name"
                        name="bank_name"
                        rules={[
                          {
                            required: true,
                            message: "This field is required !",
                          },
                        ]}
                      >
                        <Input placeholder="Bank" />
                      </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 12 }}>
                      <Form.Item
                        label="Branch Name"
                        name="branch"
                        rules={[
                          {
                            required: true,
                            message: "This field is required !",
                          },
                        ]}
                      >
                        <Input placeholder="Account Branch" />
                      </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 12 }}>
                      <Form.Item
                        label="Account Name"
                        name="acc_name"
                        rules={[
                          {
                            required: true,
                            message: "This field is required !",
                          },
                        ]}
                      >
                        <Input placeholder="Account Name" />
                      </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 12 }}>
                      <Form.Item
                        label="Account Number"
                        name="acc_number"
                        rules={[
                          {
                            required: true,
                            message: "This field is required !",
                          },
                        ]}
                      >
                        <Input placeholder="Account Number" />
                      </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} md={{ span: 12 }}>
                      <Form.Item label="Routing Number" name="routing_number">
                        <Input placeholder="Routing Number" />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              )}
              <Col xs={{ span: 24 }} md={{ span: 24 }}>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    style={{ width: "100%" }}
                    loading={loading}
                  >
                    Confirm Refund
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Drawer>
    </div>
  );
}
